export const getDefaultViewedFloorPlan = () => {
  const val = window.localStorage.getItem("viewedFloorPlan");
  if (Number.isInteger(val)) return Number(val);
};

export const removeDefaultViewedFloorPlan = () => {
  return window.localStorage.removeItem("viewedFloorPlan");
};
